var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGraphsLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.66 9.52999L10.59 16.6L6.35 12.36L7.76 10.95L10.59 13.78L16.25 8.11999L17.66 9.52999ZM4 12C4 9.66999 5.02 7.57999 6.62 6.11999L9 8.49999V2.49999H3L5.2 4.69999C3.24 6.51999 2 9.10999 2 12C2 17.19 5.95 21.45 11 21.95V19.93C7.06 19.44 4 16.07 4 12ZM22 12C22 6.80999 18.05 2.54999 13 2.04999V4.06999C16.94 4.55999 20 7.92999 20 12C20 14.33 18.98 16.42 17.38 17.88L15 15.5V21.5H21L18.8 19.3C20.76 17.48 22 14.89 22 12Z",
    fill: "#014B3E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphsLive);
export default __webpack_public_path__ + "static/media/graphs_live.9f6b8f45.svg";
export { ForwardRef as ReactComponent };